import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export const getSellerOrderHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem("authToken") || localStorage.getItem("AuthUser") || ""}`,
});

export const unwrapSellerOrders = (response) => {
    const data = response?.data?.data ?? response?.data;
    return Array.isArray(data) ? data : [];
};

export const loadSellerOrder = async (orderId) => {
    const response = await axios.get(`${apiUrl}/store-seller/my-orders`, {
        headers: getSellerOrderHeaders(),
    });
    const order = unwrapSellerOrders(response).find((item) => String(item.id) === String(orderId));

    if (!order) {
        throw new Error("Order not found in your store orders.");
    }

    // The seller's current platform fee %, used for items without a saved payout.
    return {
        ...order,
        seller_fee_percent: response?.data?.fee_percent ?? null,
        seller_storage_preference: response?.data?.storage_preference ?? null,
    };
};

export const loadSellerCouriers = async () => {
    const response = await axios.get(`${apiUrl}/store-seller/courier-companies`, {
        headers: getSellerOrderHeaders(),
    });
    const couriers = response?.data?.data ?? response?.data;
    return Array.isArray(couriers) ? couriers : [];
};

export const sellerOrderApiUrl = apiUrl;

export const formatOrderMoney = (value) => {
    if (value === null || value === undefined || value === "") return "—";
    const amount = Number(value);
    return Number.isFinite(amount) ? `$${amount.toFixed(2)}` : String(value);
};
